// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateBtcDisplayTypeMutationVariables = Types.Exact<{
  input: Types.SportsbetPreferencesUpdateBTCDisplayTypeInput;
}>;


export type UpdateBtcDisplayTypeMutation = { __typename?: 'Mutation', sportsbetPreferencesUpdateBTCDisplayType?: { __typename?: 'SportsbetPreferencesUpdateBTCDisplayTypePayload', userPreferences?: { __typename?: 'SportsbetPreferencesUserPreference', id: string, btcDisplayType: Types.BtcDisplayType }, errors?: Array<{ __typename?: 'SportsbetPreferencesError', message?: string, code?: number }> } };


export const UpdateBtcDisplayTypeMutationDocument = /*#__PURE__*/ gql`
    mutation UpdateBtcDisplayTypeMutation($input: SportsbetPreferencesUpdateBTCDisplayTypeInput!) {
  sportsbetPreferencesUpdateBTCDisplayType(input: $input) {
    userPreferences {
      id
      btcDisplayType
    }
    errors {
      message
      code
    }
  }
}
    `;
export type UpdateBtcDisplayTypeMutationMutationFn = Apollo.MutationFunction<UpdateBtcDisplayTypeMutation, UpdateBtcDisplayTypeMutationVariables>;
export function useUpdateBtcDisplayTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBtcDisplayTypeMutation, UpdateBtcDisplayTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBtcDisplayTypeMutation, UpdateBtcDisplayTypeMutationVariables>(UpdateBtcDisplayTypeMutationDocument, options);
      }
export type UpdateBtcDisplayTypeMutationHookResult = ReturnType<typeof useUpdateBtcDisplayTypeMutation>;
export type UpdateBtcDisplayTypeMutationMutationResult = Apollo.MutationResult<UpdateBtcDisplayTypeMutation>;
export type UpdateBtcDisplayTypeMutationMutationOptions = Apollo.BaseMutationOptions<UpdateBtcDisplayTypeMutation, UpdateBtcDisplayTypeMutationVariables>;